import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Select } from '@/components/ui/form';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollStatusSelect',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const { t } = useI18n();

    const value = computed({
        get: () => props.modelValue,
        set: (newValue: string) => emit('update:modelValue', newValue),
    });

    const statusOptions = computed(() => [
        { value: 'open', label: t('payrolls.grouping.open') },
        { value: 'closed', label: t('payrolls.grouping.closed') },
        { value: 'all', label: t('payrolls.grouping.all') },
    ]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    options: statusOptions.value
  }, null, 8, ["modelValue", "options"]))
}
}

})